import styled from 'styled-components'
import CertifiedPurchaseTag from '../CertifiedPurchase/Tag'

export const Link = styled.a`
  text-decoration: none;
  margin-top: auto;
`

export const LinkWithGrow = styled(Link)`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
`

export const AlignHorizontalInfoAreaStamp = styled.div`
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;

  div {
    margin-right: 5px;
    margin-bottom: 5px;
  }
`

export const AlignHeaderStamp = styled.div`
  display: flex;
  margin: 6px 0px 0 12px;
`

export const AlignSuperPrecoStamp = styled.div`
  position: absolute;
  top: 0;
  right: 12px;
`

export const AlignFlagsStamp = styled.div`
  position: absolute;
  top: 0;
  right: 6px;
  display: flex;
  flex-direction: row-reverse;
  & > div {
    margin: 0 2px;
  }
`
export const PictureWrapper = styled.div`
  position: relative;
`

export const CertifiedPurchase = styled(CertifiedPurchaseTag)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
`
